import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/gongdan_ic_shoudong@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-1a1cf2ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tl" }
const _hoisted_2 = { class: "tl_title" }
const _hoisted_3 = { class: "tl_title_left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_title_left_x" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投料信息", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "增加投料", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "tl_list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_list_item_label" }, "选择物料", -1))
const _hoisted_12 = {
  key: 0,
  class: "tl_list_item_go"
}
const _hoisted_13 = {
  key: 1,
  class: "tl_list_item_wl"
}
const _hoisted_14 = { class: "tl_list_item_wl_top" }
const _hoisted_15 = { class: "tl_list_item_wl_bottom" }
const _hoisted_16 = {
  key: 0,
  class: "green"
}
const _hoisted_17 = {
  key: 1,
  class: "yellow"
}
const _hoisted_18 = {
  key: 2,
  class: "red"
}
const _hoisted_19 = { class: "tl_list_item" }
const _hoisted_20 = { class: "tl_list_item_label" }
const _hoisted_21 = { class: "tl_list_item_go" }
const _hoisted_22 = ["onBlur", "onUpdate:modelValue"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_zw" }, null, -1))
const _hoisted_24 = { class: "tl_footer" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_26 = [
  _hoisted_25
]

import { ref, onMounted, watch } from 'vue'
    import { useRoute, useRouter } from "vue-router"
    import { queryById, createMaterial, createMaterialStandard } from '@/apis/WorkOrderAPI'
    import { Toast } from 'vant'
    import { REGULAR } from '@/utils/utils'
    import { Attribute } from '@/enum'
    // import Tooling from '@/components/common/Tooling.vue'
    import VWorkOrderInfo from '@/components/common/WorkOrderInfo.vue'
    // import Material from '@/components/common/Material.vue'
    import MaterialT from '@/components/common/MaterialT.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    // 投料索引
    let indexs = ref<number>()

    let info: any = ref({})
    let total = ref<number>(0)
    let workorderId = ref<string>('')
    let deviceId = ref<string>('')
    let gzShow = ref<boolean>(false)

    let show = ref<boolean>(false)

    // 投料信息
    let materialList: any = ref([
      {
        id: '',
        materialName: '',
        materialCode: '',
        qualityType: '',
        procedureName: '',
        locationName: '',
        batch: '',
        num: '',
        unitAttribute: ''
      }
    ])

    // 投料信息数组
    let formList: any = ref([
      {
        id: Date.now(),
        toolingTypeId: '',    // 工装类型
        toolingTypeName: '',// 工装类型名称
        workClothesId: '',    // 工装
        workClothesName: '',// 工装名称
        num: '',              // 数量
        attribute: '',         // 工装属性
        attributeType: '',         // 工装属性类型
        dw: '',         // 物料单位
        unitAttribute: ''
      }
    ])

    const gzshow = ref<boolean>(false)

    // 获取物料数据
    const getValue = (item: any) => {
      for (let i = 0; i < materialList.value.length; i++) {
        if (item.id === materialList.value[i].id) {
          Toast.fail({ message: '不能重复选择相同物料' })
          return
        }
      }
      materialList.value[indexs.value as number].id = item.id
      materialList.value[indexs.value as number].materialName = item.materialName
      materialList.value[indexs.value as number].num = item.num
      materialList.value[indexs.value as number].batch = item.batch
      materialList.value[indexs.value as number].locationName = item.locationName
      materialList.value[indexs.value as number].materialCode = item.materialCode
      materialList.value[indexs.value as number].procedureName = item.procedureName
      materialList.value[indexs.value as number].qualityType = item.qualityType
      materialList.value[indexs.value as number].unitAttribute = item.unitAttribute
      show.value = false
      // return
      //   if (!item.umodelName) {
      //       Toast.fail({ message: '该工装暂无物料，不能进行投料' })
      //       return
      //   }
      //   formList.value[indexs.value as number].toolingTypeId = item.cmodel1BigName
      //   formList.value[indexs.value as number].toolingTypeName = item.categoryId
      //   formList.value[indexs.value as number].workClothesId = item.id
      //   formList.value[indexs.value as number].workClothesName = item.code
      //   formList.value[indexs.value as number].attribute = item.smodelCode
      //   formList.value[indexs.value as number].attributeType = item.smodelLabel
      //   formList.value[indexs.value as number].dw = item.umodelName
      //   formList.value[indexs.value as number].num = item.num
      //   gzShow.value = false
    }

    const close = () => {
        show.value = false
    }

    // 失去焦点验证整数小数
    const changeNumber = (num: any, index: number, unitAttribute: number): void => {
      if (unitAttribute === 0 && num !== '') {
        if(!REGULAR.positiveInteger.test(num)){
          Toast({ message: '只能输入正整数' })
          materialList.value[index].num = ''
        }
      } else if (unitAttribute === 1 && num !== '') {
        if(!REGULAR.number.test(num)){
          Toast({ message: '只能输入正整数或小数（最多四位）' })
          materialList.value[index].num = ''
        }
      }
      if (num <= 0) {
        Toast({ message: '投料数量不能小于等于0' })
        materialList.value[index].num = ''
      }
    }

    // 打开工装弹框
    const open1 = (index: number): void => {
      indexs.value = index
      show.value = true
    }

    // 添加投料信息
    const add = (): void => {
      materialList.value.unshift({
        id: '',
        materialName: '',
        materialCode: '',
        qualityType: '',
        procedureName: '',
        locationName: '',
        batch: '',
        num: '',
        unitAttribute: ''
      })
    }

    // 删除投料信息
    const dele = (index: number): void => {
      if (materialList.value.length === 1) {
        Toast('至少保留一条投料信息')
        return
      }
      materialList.value.splice(index, 1)
    }

    // 提交手动投料
    const submit = (): void => {
      let isOpen: any = true
      materialList.value.forEach((item: any, index: number) => {
        if (!item.num) {
          Toast({ message: `请先完善第${index + 1}条投料信息`, duration: 2000 })
          isOpen = false
        }
      })
      let total: number = 0
      materialList.value.forEach((item: any, index: number) => {
        if (item.num > 0) {
          total += Number(item.num)
        }
      })
      if (info.value.bomType !== 1 && info.value.hasBom !== 1) {
        if (total > info.value.planNum) {
          Toast.fail({ message: '投料数量不能大于计划数量', duration: 2000 })
          return
        }
      }
      if (isOpen) {
        let recordList: any = []
        materialList.value.forEach((item: any) => {
          recordList.push({ wstockId: item.id, num: item.num })
        })
        createMaterialStandard({
          id: route.query.id,
          recordList: recordList
        }).then(res => {
          if (res.code === 200) {
            Toast.success({ message: '投料成功', duration: 2000, forbidClick: true })
            setTimeout(() => {
              router.go(-1)
            }, 2000)
          }
        })
      }
    }

    // 获取详情数据
    const queryByIds = (): void => {
      queryById(route.query.id).then(res => {
        if (res.code === 200) {
          info.value = res.data
          workorderId.value = route.query.id as string
          deviceId.value = res.data.pgmodel.id
        }
      })
    }

    // 根据id查询工装
    // const getListByConditions = (id: any): void => {
    //     getListByCondition({
    //         categoryId: id
    //     }).then(res => {
    //         if (res.code === 200) {
    //             console.log(res)
    //         }
    //     })
    // }

    watch(() => formList.value, (news) => {
        total.value = 0
        news.forEach((element: any) => {
            total.value = total.value + Number(element.num)
        })
    }, { deep: true })

    onMounted(() => {
      queryByIds()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(VWorkOrderInfo, { info: _unref(info) }, null, 8, ["info"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_unref(total) == 0 ? '' : _unref(total)) + _toDisplayString(_unref(formList)[_unref(formList).length - 1].dw ? _unref(formList)[_unref(formList).length - 1].dw : ''), 1)
        ]),
        _createElementVNode("div", {
          class: "tl_title_right",
          onClick: add
        }, _hoisted_8)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(materialList), (item, index) => {
        return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
          right: _withCtx(() => [
            _createVNode(_component_van_button, {
              square: "",
              style: {"height":"100%"},
              type: "danger",
              text: "删除",
              onClick: ($event: any) => (dele(index))
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "tl_list_item",
                onClick: ($event: any) => (open1(index))
              }, [
                _hoisted_11,
                (!item.materialName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(item.materialName ? 'color: #000000;' : '')
                      }, " 点击跳转到物料列表 ", 4),
                      _createVNode(_component_van_icon, {
                        name: "arrow",
                        color: "#999999"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", null, _toDisplayString(item.materialName), 1),
                        _createElementVNode("span", null, " | " + _toDisplayString(item.materialCode), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        (item.qualityType == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "合格"))
                          : (item.qualityType == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "不良"))
                            : (item.qualityType == 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "报废"))
                              : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(item.procedureName ? ` / ${item.procedureName}` : ' / -'), 1),
                        _createElementVNode("span", null, _toDisplayString(item.locationName ? ` / ${item.locationName}` : ' / -'), 1),
                        _createElementVNode("span", null, _toDisplayString(item.batch ? ` / ${item.batch}` : ' / -'), 1)
                      ])
                    ]))
              ], 8, _hoisted_10),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, "投料数量" + _toDisplayString(item.unitAttribute), 1),
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    onBlur: ($event: any) => (changeNumber(item.num, index, item.unitAttribute)),
                    "onUpdate:modelValue": ($event: any) => ((item.num) = $event)
                  }, null, 40, _hoisted_22), [
                    [_vModelText, item.num]
                  ])
                ])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "tl_footer_submit",
          onClick: submit
        }, _hoisted_26)), [
          [_directive_preventReClick]
        ])
      ])
    ]),
    _createVNode(MaterialT, {
      show: _unref(show),
      workorderId: String(_unref(workorderId)),
      deviceId: _unref(deviceId),
      onClose: close,
      onValue: getValue
    }, null, 8, ["show", "workorderId", "deviceId"])
  ], 64))
}
}

})